<script setup lang="ts">
import Button from '@components/Button.vue';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import IconList from '@icons/ph_list.svg';
import IconQuestionCircle from '@icons/ph_question-circle.svg';
import { useNavbarStore } from '@stores/layout/useNavbarStore';
import { trans } from '@elements/translation.ts';
import TooltipClick from '@components/TooltipClick.vue';
import DesktopHelpMenu from '@layout/nav-v2/desktop/components/menus/DesktopHelpMenu.vue';
import SearchLink from '@layout/nav-v2/desktop/components/SearchLink.vue';

const { toggleExpanded } = useNavbarStore();
</script>

<template>
  <div
    :class="[
      'h-full',
      'flex justify-between items-center'
    ]"
  >
    <Button
      variant="invisible"
      class="top-navbar-desktop-authenticated__menu-item"
      @click="toggleExpanded"
    >
      <Icon
        :svg="IconList"
        width="24"
        height="24"
        fill="gray-darker"
      />
    </Button>

    <SearchLink />

    <TooltipClick panel-class="top-navbar-desktop-authenticated__panel">
      <template #trigger>
        <Button
          class="top-navbar-desktop-authenticated__menu-item"
        >
          <Icon
            :svg="IconQuestionCircle"
            width="24"
            height="24"
            fill="gray-darker"
          />

          <Typography
            variant="body-bold"
            color="gray-darker"
          >
            {{ trans('user_menu.top.help') }}
          </Typography>
        </Button>
      </template>

      <template #panel="{ close }">
        <DesktopHelpMenu @intercom-open="close" />
      </template>
    </TooltipClick>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.top-navbar-desktop-authenticated {
  &__menu-item {
    @apply border-0 w-fit p-3 flex items-center space-x-2;

    @media (hover: hover) {
      &:hover {
        background: $colorBlueLightest;
      }
    }
  }
}

:deep(.top-navbar-desktop-authenticated__panel) {
  @apply right-0 mt-1 rounded-lg px-2 py-4;
}
</style>
